<template>
  <div class="ok-info-container">
    <div class="banner-container">
      <img src="../../../assets/images/ok/1.jpg" />
    </div>
    <div class="section-container info-title-box">
      <p>沟通0障碍、服务0距离、响应0时差</p>
      <div>
        <p>全新400客服平台，由内而外，亲切升级。</p>
        <p>诚意启动OK计划，从看房到入住，涵盖项目咨询、建议倾听、投诉保修……</p>
        <p>全生命周期品质人居，一键式美好体验。</p>
        <p>谁都可以找到属于自己的OK天使</p>
      </div>
    </div>
    <div class="section-container">
      <p class="info-title">【OK天使插画】400坐席情景小剧场</p>
    </div>

    <div class="section-container">
      <el-row
        class="wow animate__slideInUp info-item"
        data-wow-duration="500ms"
      >
        <el-col :span="12"
          ><div class="img-text">
            <p>悉心倾听</p>
            <p></p>
            <p>
              不必担心自己的问题不能被解决，我们将悉心倾听您的困扰，给予专业帮助。
            </p>
          </div></el-col
        >
        <el-col :span="12"
          ><div class="img-box">
            <img
              src="../../../assets/images/ok/2.jpg"
            /></div
        ></el-col>
      </el-row>
      <el-row
        class="wow animate__slideInUp info-item"
        data-wow-duration="500ms"
      >
        <el-col :span="12"
          ><div class="img-box">
            <img
              src="../../../assets/images/ok/3.jpg"
            /></div
        ></el-col>
        <el-col :span="12"
          ><div class="img-text">
            <p>真诚记录</p>
            <p></p>
            <p>1小时内将有服务专员与您取得联系，进行接下来的跟进处理。</p>
          </div></el-col
        >
      </el-row>
      <el-row
        class="wow animate__slideInUp info-item"
        data-wow-duration="500ms"
      >
        <el-col :span="12"
          ><div class="img-text">
            <p>及时跟进</p>
            <p></p>
            <p>
              我们将及时提醒服务专员主动与您联系，并预约服务时间、提供解决方案。
            </p>
          </div></el-col
        >
        <el-col :span="12"
          ><div class="img-box">
            <img
              src="../../../assets/images/ok/4.jpg"
            /></div
        ></el-col>
      </el-row>
      <el-row
        class="wow animate__slideInUp info-item"
        data-wow-duration="500ms"
      >
        <el-col :span="12"
          ><div class="img-box">
            <img
              src="../../../assets/images/ok/5.jpg"
            /></div
        ></el-col>
        <el-col :span="12"
          ><div class="img-text">
            <p>全程监督</p>
            <p></p>
            <p>
              我们将对服务专员的工作态度、服务过程等进行全程监督，杜绝拖办、延办等现象。
            </p>
          </div></el-col
        >
      </el-row>
      <el-row
        class="wow animate__slideInUp info-item"
        data-wow-duration="500ms"
      >
        <el-col :span="12"
          ><div class="img-text">
            <p>服务保障</p>
            <p></p>
            <p>
              如您反映的问题未按规范处理，我们将提供服务升级保障，确保问题专人跟进。
            </p>
          </div></el-col
        >
        <el-col :span="12"
          ><div class="img-box">
            <img
              src="../../../assets/images/ok/6.jpg"
            /></div
        ></el-col>
      </el-row>
      <el-row
        class="wow animate__slideInUp info-item"
        data-wow-duration="500ms"
      >
        <el-col :span="12"
          ><div class="img-box">
            <img
              src="../../../assets/images/ok/7.jpg"
            /></div
        ></el-col>
        <el-col :span="12"
          ><div class="img-text">
            <p>满意回访</p>
            <p></p>
            <p>
              客户满意是衡量我们工作的第一标准。如您不认可的事项，我们将进行再次处理。
            </p>
          </div></el-col
        >
      </el-row>

      <div class="footer-title-box">
        <p class="footer-title">OK天使服务范围</p>
      </div>
      <el-row>
        <el-col :span="8">
          <div class="footer-text footer-text1">
            <img
              class="wow animate__flipIn"
              data-wow-duration="1000ms"
              src="../../../assets/images/ok/8.jpg"
              alt=""
            />
            <p>项目咨询</p>
            <p>
              销售项目、小区物业信息查询、交付时间及材料准备查询、不动产办理查询、其他业主服务类帮助等全方位服务。
            </p>
          </div>
        </el-col>
        <el-col :span="8"
          ><div class="footer-text footer-text2">
            <img
              class="wow animate__flipIn"
              data-wow-duration="1000ms"
              src="../../../assets/images/ok/9.jpg"
              alt=""
            />
            <p>建议倾听</p>
            <p>
              产品建议、小区改善建议、表扬受理（针对工作人员或团队在工作中的服务表扬）。
            </p>
          </div></el-col
        >
        <el-col :span="8"
          ><div class="footer-text footer-text3">
            <img
              class="wow animate__flipIn"
              data-wow-duration="1000ms"
              src="../../../assets/images/ok/10.jpg"
              alt=""
            />
            <p>投诉保修</p>
            <p>
              受理客户的房屋内、公区等报修，针对新希望地产客户全生命周期中，客户在售、交付、入住等阶段的任何投诉均可受理。
            </p>
          </div></el-col
        >
      </el-row>

      <div class="footer-title-box">
        <p class="footer-title">只为更好的你</p>
        <p class="footer-tip">
          建筑品质是宜居的基础。无微不至的客户服务，才让每一方土地有了温度。
        </p>
      </div>
      <el-row>
        <el-col :span="8">
          <div class="footer-text footer-text1">
            <img
              class="wow animate__flipIn"
              data-wow-duration="1000ms"
              src="../../../assets/images/ok/11.jpg"
              alt=""
            />
            <p>3声振铃内必接</p>
          </div>
        </el-col>
        <el-col :span="8"
          ><div class="footer-text footer-text2">
            <img
              class="wow animate__flipIn"
              data-wow-duration="1000ms"
              src="../../../assets/images/ok/12.jpg"
              alt=""
            />
            <p>1小时内正确转办</p>
          </div></el-col
        >
        <el-col :span="8"
          ><div class="footer-text footer-text3">
            <img
              class="wow animate__flipIn"
              data-wow-duration="1000ms"
              src="../../../assets/images/ok/13.jpg"
              alt=""
            />
            <p>1天满意回访</p>
          </div></el-col
        >
      </el-row>

      <div class="bottom-box">
        <p>OK客户服务热线：400-823-5566</p>
        <p>“新希望·OK天使”全天候为您真诚服务</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "OkInfoPage",
  mounted() {
    this.$nextTick(() => {
      this.$wow.init();
    });
  },
};
</script>
<style lang="scss" scoped>
.ok-info-container {
  .info-title-box {
    box-sizing: border-box;
    padding: 80px 0;
    text-align: center;

    > p {
      color: #00803e;
      font-size: 26px;
    }

    > div {
      margin-top: 35px;
      font-size: 15px;
      color: #565c61;
      font-weight: 300;
      line-height: 35px;
    }
  }

  .info-title {
    text-align: center;
    color: #00803e;
    font-size: 26px;
    margin-bottom: 50px;
  }

  .info-item {
    background-color: #f3f3f3;

    .img-text {
      padding-top: 80px;
      padding-bottom: 80px;
      padding-left: 80px;
      padding-right: 100px;

      > p {
        &:first-child {
          color: #00803e;
          font-size: 26px;
        }

        &:nth-child(2) {
          width: 16px;
          height: 2px;
          margin-top: 20px;
          margin-bottom: 30px;
          background: #00803e;
        }

        &:nth-child(3) {
          font-size: 15px;
          color: #565c61;
          text-align: justify;
          line-height: 28px;
        }
      }
    }

    .img-box {
      overflow: hidden;
      > img {
        width: 100%;
        height: auto;
        vertical-align: top;
      }
    }
  }
  .footer-title-box {
    box-sizing: border-box;
    padding-top: 110px;
    text-align: center;
  }
  .footer-title {
    color: #fff;
    background-color: #00803e;
    font-size: 24px;
    display: inline-block;
    padding: 0 10px;
    border-radius: 5px;
  }

  .footer-text {
    padding-top: 50px;
    padding-bottom: 20px;

    > img {
      width: 50px;
    }

    > p:nth-child(2) {
      font-size: 18px;
      margin-top: 15px;
      margin-bottom: 10px;
      color: #292c2e;
    }

    > p:nth-child(3) {
      color: #565c61;
      font-size: 14px;
    }

    &1 {
      text-align: center;
      padding-left: 100px;
    }
    &2 {
      text-align: center;
      padding-left: 50px;
      padding-right: 50px;
    }
    &3 {
      text-align: center;
      padding-right: 100px;
    }
  }

  .footer-tip {
    text-align: center;
    color: #565c61;
    font-size: 14px;
    margin-top: 35px;
  }

  .bottom-box {
    width: 100%;
    max-width: 850px;
    margin: 0 auto;
    padding: 35px;
    margin-top: 50px;
    border-bottom: 1px solid #565c61;
    border-top: 1px solid #565c61;
    font-weight: 200;
    font-size: 22px;
    color: #565c61;
    text-align: center;
    line-height: 32px;
  }
}
</style>
